import ContactRolesMainPage from './subPages/contactRoles';
import AssetsMainPage from './subPages/assets';
import ManagerMainPage from './subPages/managers';
import LeasingContactsMainPage from './subPages/leasingContacts';
import RoomsMainPage from './subPages/rooms';
import VisitCardPage from './subPages/visitCard';
import LeasingPlans from './subPages/leasingPlans';
import MeetingTypesMainPage from './subPages/meetingTypes';

const routes = [
  {
    path: '/contact_role/*',
    canUse: [],
    Component: ContactRolesMainPage,
  },
  {
    path: '/asset/*',
    canUse: [],
    Component: AssetsMainPage,
  },
  {
    path: '/manager/*',
    canUse: [],
    Component: ManagerMainPage,
  },
  {
    path: '/leasing_contacts/*',
    canUse: [],
    Component: LeasingContactsMainPage,
  },
  {
    path: '/room/*',
    canUse: [],
    Component: RoomsMainPage,
  },
  {
    path: '/visit_card/*',
    canUse: [],
    Component: VisitCardPage,
  },
  {
    path: '/plans/*',
    canUse: [],
    Component: LeasingPlans,
  },
  {
    path: '/meeting_types/*',
    canUse: [],
    Component: MeetingTypesMainPage,
  },
];

export default routes;
